<!-- Desktop -->
<!-- <footer>
    <p class="text-center">
            © Copyright 2022. All Rights Reserved. Powered by {{env.host.dName}}.
    </p>
</footer> -->
<!-- Desktop -->
<div class="inner-footer">
    <div class="row">
      <div class="col-12">
        <div class="support" *ngIf="env.host.footer.isShow">
            <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4 col-6">
                  <h2>24X7 Support</h2>
                </div>
                <div class="col-md-4 col-6">
                  <div class="social_links" *ngIf="env.host.social.isShow">
                    <a *ngIf="env.host.social.fbLink != ''" [href]="env.host.social.fbLink" target="_blank">
                      <img class="img-fluid" src="https://cdn-icons-png.flaticon.com/512/2504/2504903.png">
                    </a>
                    <a *ngIf="env.host.social.instaLink != ''" [href]="env.host.social.instaLink" target="_blank">
                      <img class="img-fluid" src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png">
                    </a>
                    <a *ngIf="env.host.social.telLink != ''" [href]="env.host.social.telLink" target="_blank">
                      <img class="img-fluid" src="https://cdn-icons-png.flaticon.com/512/2504/2504941.png">
                    </a>
                  </div>
                </div>
              </div>
        </div>
        <div class="footer-menu" *ngIf="env.host.footer.isShow">
          <ul>
            <li><a href="javascript:void(0)">About Us</a></li>
            <li><a href="javascript:void(0)">Game Rules</a></li>
            <li><a href="javascript:void(0)">FAQ</a></li>
            <li><a href="javascript:void(0)">Terms and Conditions</a></li>
            <li><a href="javascript:void(0)">Responsible Gaming</a></li>
          </ul>
        </div>
        <div class="footer-top" *ngIf="env.host.footer.isShow">
          <div class="secure-logo">
            <div>
              <img src="https://speedcdn.io/assets/diamond-client-v8/ssl.png" alt="ssl">
            </div>
            <div class="ml-2">
              <b>100% SAFE</b>
              <div>
                Protected connection and encrypted data.
              </div>
            </div>
          </div>
          <div class="d-inline-block footer-other">
            <a href="javascript:void(0)" role="button" class="final-link"><img src="https://speedcdn.io/assets/diamond-client-v8/18plus.png"></a>
            <a href="https://www.gamcare.org.uk/" target="_blank"><img src="https://speedcdn.io/assets/diamond-client-v8/gamecare.png"></a>
            <a href="https://www.gamblingtherapy.org/en" target="_blank"><img src="https://speedcdn.io/assets/diamond-client-v8/gt.png"></a>
          </div>
        </div>
        <p class="site-info" *ngIf="env.host.footerbottom.isShow">
          Welcome to 1xbetfair, a one-stop solution for all your needs related to playing online betting and casino games. Your every bet and spin on our platform takes you a step forward to huge winnings and enticing experiences. 1xbetfair is renowned for offering a top-notch online gaming experience to its users, whether you are browsing our massive array of casino games or you are betting on tennis, cricket, and football. Responsible gaming is always the topmost priority of our platform, particularly for those players who are 18 years of age and above. 1xbetfair is licensed and regulated by the Curacao Authority and our N.V. License <b>No.is: B2C-669UN7GS-2678JAZ</b>. It is the responsibility of our users to make sure that they make use of our services lawfully in their jurisdiction incorporating non-gaming territories. Join our platform now to have a fantastic gaming experience.
        </p>
        <div class="text-center py-1 w-100 copyright" *ngIf="env.host.footerbottom.isShow">
            &copy; Copyright 2024. All Rights Reserved. Powered by {{env.host.dName}}.
        </div>
      </div>
    </div>
  </div>
  
  <!-- Mobile -->
  <!-- <footer class="d-none">
      <p class="text-center">
              © Copyright 2022. All Rights Reserved. Powered by {{env.host.dName}}.
      </p>
  </footer> -->
  <!-- Mobile -->
  